export const DELAY = 'DELAY';
export const BRANCH = 'BRANCH';
export const CLEAR_CONTACT_PROPERTY = 'CLEAR_CONTACT_PROPERTY';
export const CLEAR_COMPANY_PROPERTY = 'CLEAR_COMPANY_PROPERTY';
export const COPY_COMPANY_PROPERTY = 'COPY_COMPANY_PROPERTY';
export const COPY_PROPERTY = 'COPY_PROPERTY';
export const EMAIL = 'EMAIL';
export const EMPTY = 'EMPTY';
export const INCREMENT_COMPANY_PROPERTY = 'INCREMENT_COMPANY_PROPERTY';
export const ADD_SUBTRACT_PROPERTY = 'ADD_SUBTRACT_PROPERTY';
export const NOTIFICATION = 'NOTIFICATION';
export const SET_COMPANY_PROPERTY = 'SET_COMPANY_PROPERTY';
export const SET_CONTACT_PROPERTY = 'SET_CONTACT_PROPERTY';
export const SMS_NOTIFICATION = 'SMS_NOTIFICATION';
export const SEND_NOTIFICATION = 'NOTIFICATION_STATION';
export const UPDATE_LIST = 'UPDATE_LIST';
export const REMOVE_LIST = 'REMOVE_LIST';
export const WEBHOOK = 'WEBHOOK';
export const WHILE_LOOP = 'WHILE_LOOP';
export const WORKFLOW_ENROLLMENT = 'WORKFLOW_ENROLLMENT';
export const SET_SALESFORCE_CAMPAIGN_MEMBERSHIP = 'SET_SALESFORCE_CAMPAIGN_MEMBERSHIP';
export const CREATE_SFDC_TASK = 'CREATE_SFDC_TASK';
export const TASK = 'TASK';
export const DEAL = 'DEAL';
export const TICKET = 'TICKET';
export const LEAD_ASSIGNMENT = 'LEAD_ASSIGNMENT';
export const DATE_STAMP_PROPERTY = 'DATE_STAMP_PROPERTY';
export const ADD_CONTACT_ENUM_PROPERTY = 'ADD_CONTACT_ENUM_PROPERTY';
export const ADD_COMPANY_ENUM_PROPERTY = 'ADD_COMPANY_ENUM_PROPERTY';
export const EXTENSION = 'EXTENSION';
export const UNSUPPORTED_ACTION = 'UNSUPPORTED_ACTION';